// removed by extract-text-webpack-plugin
module.exports = {"container":"Footer__container___GmT_B","cventLinks":"Footer__cventLinks___2cfWa","marketingLinks":"Footer__marketingLinks___1v5pr","policyLinks":"Footer__policyLinks___3nbZ_","list":"Footer__list___3q1As","link":"Footer__link___1JkvQ","copyright":"Footer__copyright___2Bdpv","logoImage":"Footer__logoImage___2Voeq"};


//////////////////
// WEBPACK FOOTER
// ./~/nucleus-widgets/lib/Footer/Footer.less
// module id = ./node_modules/nucleus-widgets/lib/Footer/Footer.less
// module chunks = 55